import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    'menu':"false"
};


const MenuSlice = createSlice({
    name: 'current menu show mode',
    initialState,
    reducers: {
        menuPH: (state, action) => {
            if (state.menu === "false") {
                state.menu = "true";
            }
            else {
                state.menu = "false";
            }
        }
    }
});

export const { menuPH } = MenuSlice.actions;
export default MenuSlice.reducer;
